const colorStyles = {
  isPrimary: {
    color:'#1fc8db',
  },
  isPrimaryBackground: {
    backgroundColor: '#0C6FC0',
  },
  isSecondary: {
    color: '#BCD6ED',
  },  
  isSecondaryBackground: {
    backgroundColor: '#BCD6ED',
  },
  activeButton: {
    backgroundColor: '#42afe3',
    color: 'white',
  },
  isInfo: {
    color:'#42afe3',
  },
  isSuccess: {
    color:'#97cd76',
  },
  isWarning: {
    color:'#fce473',
  },
  isDanger: {
    color:'#ed6c63',
  },
  isLink: {
    color:'#69707a',
  },
  isWhite: {
    color:'white',
  },
  isLight: {
    color:'#f5f7fa',
  },
  isDark: {
    color:'#69707a',
  },
  isBlack: {
    color:'black',
  },
};

export default colorStyles;
